import { loadFixture, paginate, parseQuery } from '../mockDataStore';

export default function registerNotificationMocks(mock) {
  mock.onGet(/^\/?api\/v1\/notifications\/?(\?.*)?$/).reply(async (config) => {
    const notifications = await loadFixture('notifications/notifications');
    return [200, paginate(notifications.results, parseQuery(config.url))];
  });

  // Unlike the list endpoint above, the real backend returns a plain array here (the
  // Vuex action commits `data` directly, not `data.results`) — match that shape exactly.
  mock.onGet(/^\/?api\/v1\/notifications\/mark_as_read\/?$/).reply(async () => {
    const notifications = await loadFixture('notifications/notifications');
    notifications.results.forEach((notification) => {
      notification.is_read = true;
    });
    return [200, notifications.results];
  });
}
